// ViewClientPage.js - Full API Integration with Inline Comments

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

function ViewClientPage({ apiRoutes }) {
  const { id } = useParams(); // Get client ID from URL
  const navigate = useNavigate();
  const [client, setClient] = useState(null);

  // Fetch client data from the server
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const response = await fetch(apiRoutes.getClient(id));
        const data = await response.json();
        setClient(data);
      } catch (error) {
        console.error("Failed to fetch client data:", error);
      }
    };
    fetchClient();
  }, [id, apiRoutes]);

  if (!client) return <p>Loading client details...</p>;

  return (
    <div>
      <h2>View Client Tour</h2>
      <p><strong>Client Name:</strong> {client.client_name}</p>
      <p><strong>Phone:</strong> {client.phone}</p>
      <p><strong>Entering Date:</strong> {client.enter_date ? new Date(client.enter_date).toLocaleString() : ""}</p>
      <p><strong>Leaving Date:</strong> {client.leave_date ? new Date(client.leave_date).toLocaleString() : ""}</p>
      <p><strong>Agent Name:</strong> {client.agent_name}</p>
      <p><strong>Number of People:</strong> {client.num_people}</p>
      <p><strong>Accommodation Address:</strong> {client.accommodation_address}</p>
      <p><strong>Accommodation Booked:</strong> {client.accommodation ? "Yes" : "No"}</p>
      <p><strong>Who Paid:</strong> {client.who_paid}</p>
      <p><strong>Transfer Booked:</strong> {client.transfer_booked ? "Yes" : "No"}</p>
      <p><strong>Costs:</strong> {client.costs}</p>
      <p><strong>Additional Costs:</strong> {client.additional_costs}</p>
      <p><strong>Car:</strong> {client.car}</p>
      <p><strong>Client Description:</strong> {client.client_description}</p>
      <p><strong>Result:</strong> {client.result}</p>
      <p><strong>Request:</strong> {client.request}</p>
      <p><strong>What They Choose:</strong> {client.what_they_choose}</p>
      <p><strong>Discounts:</strong> {client.discounts}</p>
      <p><strong>Date of Down Payment:</strong> {client.down_payment_date ? new Date(client.down_payment_date).toLocaleString() : ""}</p>
      <p><strong>Price of the Property:</strong> {client.property_price}</p>

      {/* Display Uploaded Photos */}
      {client.passport_photo ? (
        <div>
          <h3>Passport Photo</h3>
          <img src={client.passport_photo} alt="Passport" style={{ maxWidth: "200px" }} />
        </div>
      ) : <p>No Passport Photo Available</p>}

      {client.ticket_photo ? (
        <div>
          <h3>Ticket Photo</h3>
          <img src={client.ticket_photo} alt="Ticket" style={{ maxWidth: "200px" }} />
        </div>
      ) : <p>No Ticket Photo Available</p>}

      <button onClick={() => navigate("/")}>Back to Home</button>
      <button onClick={() => navigate(`/edit/${client.id}`)}>Edit Client</button>
    </div>
  );
}

export default ViewClientPage;
